<template>
  <div class="template">

    <video src="http://tiigbg.se/digitaltperspektiv/assets/videos/Drottningens%20juvelsmycke-2.mp4" class="border" controls></video>
    <br/>
    Otto Fischer om romanbygget, allkonstverket och Tintomara-gestalten

    <br /><br />

    <video src="http://tiigbg.se/digitaltperspektiv/assets/videos/Edenborg.mp4" class="border" controls></video>
    <br />
    Carl-Michael Edenborg om Almqvist, alkemi och Anckarström

  </div>
</template>

<script>
export default {
  name: 'DJPerspectives',
  readable: 'Perspektiv',
  route: 'perspektiv',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

video{
  width: 50%;
}

.border{
  border: 1px solid gray;
}

</style>



// WEBPACK FOOTER //
// src/components/objects/drottningensjuvelsmycke/tabs/DJPerspectives.vue